import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    redirect: "/:channelNo/register",
  },
  {
    path: "/:channelNo/register",
    name: "register",
    component: () => import("@/views/register/index.vue"),
    meta: {
      pageName: "注册",
      scName: "注册页", // 神策上报当前页面名称，优先scName，其次pageName
    },
  },
  {
    path: "/:channelNo/sms",
    name: "sms",
    component: () => import("@/views/register/sms.vue"),
    meta: {
      pageName: "发送验证码",
      scName: "发送验证码页",
    },
  },
  {
    path: "/:channelNo/perfect",
    name: "perfect",
    component: () => import("@/views/perfect/index.vue"),
    meta: {
      pageName: "完善信息",
      scName: "完善信息页",
    },
  },
  {
    path: "/:channelNo/chooseHospital",
    name: "chooseHospital",
    component: () => import("@/views/perfect/chooseHospital.vue"),
    meta: {
      pageName: "选择医院",
      scName: "选择医院页",
    },
  },
  {
    path: "/:channelNo/word",
    name: "word",
    component: () => import("@/views/perfect/word.vue"),
    meta: {
      pageName: "口令",
      scName: "口令页",
    },
  },

  {
    path: "/:channelNo/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      pageName: "首页",
      keepAlive: true
    }
  },
  ,
  {
    path: "/:channelNo/list",
    name: "list",
    component: () => import("@/views/list/index.vue"),
    meta: {
      pageName: "查看全部",
      scName: '更多列表页',
      keepAlive: true
    }
  },
  {
    path: "/:channelNo/search",
    name: "search",
    component: () => import("@/views/search/index.vue"),
    meta: {
      pageName: "搜索",
      keepAlive: true
    }
  },
  {
    path: "/:channelNo/info/:id",
    name: "infoDetail",
    component: () => import("@/views/info/index.vue"),
    meta: {
      pageName: "文章",
      scName: "文章详情页",
    },
  },
  {
    path: "/:channelNo/case/:id",
    name: "caseDetail",
    component: () => import("@/views/case/index.vue"),
    meta: {
      pageName: "文章",
      scName: "文章详情页",
    },
  },
  {
    path: "/:channelNo/living/:id",
    name: "liveDetail",
    component: () => import("@/views/living/index.vue"),
    meta: {
      pageName: "直播",
      scName: "直播详情页",
    },
  },
  {
    path: "/:channelNo/courseDetail/:id",
    name: "courseDetail",
    component: () => import("@/views/course/index.vue"),
    meta: {
      pageName: "录播",
      scName: "录播详情页",
    },
  },
  {
    path: "/:channelNo/survey/:id",
    name: "surveyDetail",
    component: () => import("@/views/survey/index.vue"),
    meta: {
      pageName: "问卷",
      scName: "问卷详情页",
    },
  },
  {
    path: "/:channelNo/surveyFinish/:id",
    name: "surveyFinish",
    component: () => import("@/views/survey/finish.vue"),
    meta: {
      pageName: "提交成功",
      scName: "问卷完成页",
    },
  },
  {
    path: "/:channelNo/game",
    name: "game",
    component: () => import("@/views/game/list.vue"),
    meta: {
      pageName: "游戏列表",
      scName: "游戏列表页",
    },
  },
  {
    path: "/:channelNo/rewardLog",
    name: "gameRewardLog",
    component: () => import("@/views/game/rewardLog.vue"),
    meta: {
      pageName: "游戏中奖记录列表",
      scName: "游戏中奖记录列表页",
    },
  },
  {
    path: "/:channelNo/editAddress",
    name: "gameEditAddress",
    component: () => import("@/views/game/editAddress.vue"),
    meta: {
      pageName: "编辑收货地址",
      scName: "编辑收货地址页",
    },
  },
  {
    path: "/:channelNo/game/puzzle/:id",
    name: "puzzleGame",
    component: () => import("@/views/game/puzzle/index.vue"),
    meta: {
      pageName: "拼图游戏",
      scName: "拼图游戏页",
    },
  },
  {
    path: "/:channelNo/game/puzzle/:id/main",
    name: "puzzleGameMain",
    component: () => import("@/views/game/puzzle/main.vue"),
    meta: {
      pageName: "拼图游戏开始",
      scName: "拼图游戏开始页",
    },
  },
  {
    path: "/:channelNo/game/puzzle/:id/rule",
    name: "puzzleGameRule",
    component: () => import("@/views/game/puzzle/rule.vue"),
    meta: {
      pageName: "拼图游戏规则",
      scName: "拼图游戏规则页",
    },
  },
  {
    path: "/:channelNo/person",
    name: "person",
    component: () => import("@/views/person/home.vue"),
    meta: {
      pageName: "个人中心",
      scName: '个人中心页'
    }
  },
  {
    path: "/:channelNo/person/integral",
    name: "integral",
    component: () => import("@/views/person/integral.vue"),
    meta: {
      pageName: "个人中心",
      scName: '我的积分页'
    }
  },
  {
    path: "/:channelNo/person/collection",
    name: "collection",
    component: () => import("@/views/person/collection.vue"),
    meta: {
      pageName: "我的收藏",
      scName: '我的收藏页'
    }
  },
  {
    path: "/:channelNo/person/setting",
    name: "setting",
    component: () => import("@/views/perfect/index.vue"),
    meta: {
      pageName: "个人设置",
      scName: '个人设置页'
    }
  },
  {
    path: "/:channelNo/activityList",
    name: "activityList",
    component: () => import("@/views/activityList/index.vue"),
    meta: {
      pageName: "热门活动",
      scName: '热门活动页'
    }
  },
  {
    path: "/:channelNo/stop",
    name: "stop",
    component: () => import("@/views/stop/index.vue"),
    meta: {
      pageName: "停用",
      scName: '停用/删除页'
    }
  },
  {
    path: "/:channelNo/liveShareCard/:id",
    name: "liveShareCard",
    component: () => import("@/views/liveShareCard/index.vue"),
    meta: {
      pageName: "邀请卡",
      scName: '邀请卡页'
    }
  }
];

export default new Router({
  mode: process.env.VUE_APP_ROUTE_TYPE, // require service support
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: constantRouterMap,
});

export const asyncRouterMap = [];
